import API from 'services/TAPS_API';
import { NDFL3_NOTIFICATION_ID } from 'modules/Taps/constants';

export default function getPropertyDeductionBalance(params) {
  return API.request({
    method: 'GET',
    url: `/notification/${NDFL3_NOTIFICATION_ID}/property-deduction-balance`,
    params,
  });
}
